<ngx-bootstrap-multiselect [options]="options$ | async" [(ngModel)]="selectedOptions" [settings]="settings"></ngx-bootstrap-multiselect>
